import { useEffect, useId } from 'react';

/**
 * Sets the inert attribute on the payment element when it is hidden.
 */
export const useInertPaymentElement = (isHidden: boolean) => {
  const id = useId();

  useEffect(() => {
    const element = document.getElementById(id);

    if (!isHidden || !element || element.hasAttribute('inert')) return;

    element.setAttribute('inert', '');

    return () => {
      element.removeAttribute('inert');
    };
  }, [id, isHidden]);

  return id;
};
